export default __webpack_public_path__ + "static/media/do-icon-new.cb045f6e.svg";